import { Directive, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Observable } from "rxjs";
import { select, Store } from "@ngrx/store";
import { DashboardItem } from "../../models/dashboard-item";
import * as dashboardActions from "../../actions/dashboard-actions";
import * as dashboardSelectors from "../../selectors/dashboard-selectors";
import { ConfirmationService } from "primeng/api";
import {OnDestroySubject} from "@common/components/on-destroy-subject";

@Directive()
export class WidgetComponent
  extends OnDestroySubject
  implements OnInit {
  @Input()
  widget: DashboardItem = undefined;
  @Input()
  isDashboardDesignerMode;
  @Output()
  onMaximise = new EventEmitter<any>();
  @Output()
  onRestore = new EventEmitter<any>();
  maximisedWidget$: Observable<DashboardItem>;

  constructor(
    protected store: Store<any>,
    protected confirmationService: ConfirmationService) {
    super();
  }

  ngOnInit() {
    this.maximisedWidget$ = this.store.pipe(
      select(dashboardSelectors.getMaximisedWidget(this.widget.dashboardName)),
    );
  }

  maximise() {
    this.store.dispatch(new dashboardActions.Maximise(this.widget));
  }

  restore() {
    this.store.dispatch(new dashboardActions.Restore());
  }

  delete() {
    this.confirmationService.confirm({
      message: `Are you sure that you want to remove this widget?`,
      header: "Confirmation",
      // icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.store.dispatch(new dashboardActions.DeleteItem(this.widget));
      },
    });
  }
}
